import { lazy } from 'react'

export const EmailConsentV1 = lazy(() => import('./v1/EmailConsentV1'))
export const EmailConsentV2 = lazy(() => import('./v2/EmailConsentV2'))
export const EmailConsentV3 = lazy(() => import('./v3/EmailConsentV3'))
